import React from 'react'

const Computer = () => {
  return (
    <svg
      width="40"
      height="32"
      viewBox="0 0 40 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M35.5556 0H4.44444C2 0 0 2 0 4.44444V27.5556C0 30 2 32 4.44444 32H35.5556C38 32 40 30 40 27.5556V4.44444C40 2 38.0222 0 35.5556 0ZM25.4 18.9778L22.8667 20L25.3111 22.4444C25.7778 22.9111 25.7778 23.6444 25.3111 24.1111L24.9111 24.5111C24.4444 24.9778 23.7111 24.9778 23.2444 24.5111L20.8 22.0667L19.7778 24.6C19.5778 25.0889 18.8889 25.0889 18.6889 24.6L14.2889 14.2667C14.0889 13.7778 14.5778 13.2889 15.0667 13.4889L25.4 17.8667C25.8889 18.0889 25.8889 18.7778 25.4 18.9778ZM36.2222 8.86667H3.77778C3.53333 8.86667 3.33333 8.66667 3.33333 8.42222V4.44444C3.33333 3.82222 3.82222 3.33333 4.44444 3.33333H35.5556C36.1778 3.33333 36.6667 3.82222 36.6667 4.44444V8.42222C36.6667 8.66667 36.4667 8.86667 36.2222 8.86667Z"
        fill="#C58C5F"
      />
    </svg>
  )
}

export default Computer
